import React, { useContext, useLayoutEffect, useState } from "react";
import { ImageBuilder } from "../../global/image-builder";
import {
  faChartLine, faPeopleGroup, faSuitcase, faThumbsUp, faWifi
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SiteContext } from "../../global/site-context";
import { makeLogoUrl } from "../../../containers/layout";

const SPEED = 3500;
const BORDER_WIDTH = 18;
const ROTATE = [
  {
    verb: "Checking",
    suffix: "business model",
    icon: faSuitcase,
  },
  {
    verb: "Researching",
    suffix: "funding",
    icon: faChartLine,
  },
  {
    verb: "Looking up",
    suffix: "team size",
    icon: faPeopleGroup,
  },
  {
    verb: "Checking",
    suffix: "social presence",
    icon: faThumbsUp,
  },
  {
    verb: "Looking up",
    suffix: "website traffic",
    icon: faWifi,
  }
];

export const Distraction = ({ domain }) => {
  const site = useContext(SiteContext);
  const [index, setIndex] = useState(0);

  useLayoutEffect(() => {
    const timeout = setTimeout(() => {
      setIndex((index < ROTATE.length - 1) ? index + 1 : 0);
    }, SPEED);

    return () => clearTimeout(timeout);
  }, [index]);

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center justify-center mb-20">
        <BigIcon icon={ROTATE[index].icon} />
      </div>
      <div
        className="mb-8 text-5xl gap-5 items-center w-full"
        style={{
          display: site.isNotMobile ? "grid" : "flex flex-col",
          gridTemplateColumns: site.isNotMobile ? "44% auto 1fr" : null,
          minHeight: 80,
        }}
      >
        <div className="flex justify-center md:justify-end">{ROTATE[index].verb}</div>
        <div className="flex justify-center my-4 md:my-0">
          <ImageBuilder
            src={makeLogoUrl(domain)}
            className="bg-white p-3 rounded-md"
            style={{ maxWidth: 120, maxHeight: 80 }}
          />
        </div>
        <div className="flex justify-center md:justify-start">
          {ROTATE[index].suffix}...
        </div>
      </div>
      {/* <div className="text-3xl text-light-20">
        {ROTATE[(index < ROTATE.length - 1) ? index + 1 : 0].verb} {ROTATE[(index < ROTATE.length - 1) ? index + 1 : 0].suffix}...
      </div> */}
    </div >
  )
};

export const BigIcon = ({ icon }) => (
  <div className="border border-light-5 rounded-full animate-breath"
    style={{ borderWidth: BORDER_WIDTH }}
  >
    <div className="border border-light-10 rounded-full animate-breath delay-1500 duration-3500"
      style={{ borderWidth: BORDER_WIDTH }}
    >
      <div className="border border-light-20 rounded-full animate-breath delay-3000 duration-4000"
        style={{ borderWidth: BORDER_WIDTH }}
      >
        <div className="text-green-emerald border border-green-emerald bg-dark-20 rounded-full w-20 h-20 flex items-center justify-center">
          <FontAwesomeIcon
            icon={icon}
            size="2x"
          />
        </div>
      </div>
    </div>
  </div>
)

// const CHATTER = [
//   "website traffic...", "social presence...", "team size...", "funding...",
//   "business model...", "sales strategy...", "signal sources...",
//   "growth opportunity...", "dark funnel signals...", "revenue potential...",
//   "market fit...", "data enrichment...", "playbook suggestions...",
//   "segment accuracy...", "customer engagement...", "AI suggestions...",
//   "...", "almost there...", "just a moment...",
//   "...", "still thinking...", "sorry...",
//   ".", "..", "...", "thanks for your patience...",
//   ".", "..", "...", "you've waiting this long...",
//   ".", "..", "...", "call us maybe?",
//   ".", "..", "...", "PLEASE REFRESH",
//   ".", "..", "...", "PLEASE REFRESH",
//   ".", "..", "...", "PLEASE REFRESH"];